import React from 'react';
import OnboardingNav from './OnboardingNav';
import OnboardingProvider from './OnboardingProvider';
import OnboardingSteps from './OnboardingSteps';
import OnboardingStep from './OnboardingStep';
import { onBoardingAPI } from '../../InterfaceAPI/onboardingAPI';
import { breakpoints } from '../../const';
import OnboardingSubmitContainer from './OnboardingSubmitContainer';
import OnboardingSubmitConfirm from './OnboardingSubmitConfirm';
import OnboardingSubmitSkip from './OnboardingSubmitSkip';
import OnboardingSubmitDefault from './OnboardingSubmitDefault';
import ClientContact from './client/ClientContact';
import ClientContactNav from './client/ClientContactNav';
import ClientServiceTime from './client/ClientServiceTime';
import ClientServiceTimeNav from './client/ClientServiceTimeNav';
import ClientStartDate from './client/ClientStartDate';
import ClientStartDateNav from './client/ClientStartDateNav';
import ClientMenu from './client/ClientMenu';
import ClientMenuNav from './client/ClientMenuNav';
import ClientPreferences from './client/ClientPreferences';
import ClientPreferencesNav from './client/ClientPreferencesNav';
import ClientDetails from './client/ClientDetails';
import { stringfyServerErrors } from '../../helpers/util';
import withSplashMessage from '../splashMessage/withSplashMessage';
// import OnboardingResetButton from './OnboardingResetButton';
import ENV_CONFIG from '../../env';
import withTracker from '../withTracker';

class ClientOnboarding extends React.Component {
  // Overall plan for this flow so far (and chef on boarding):
  // Each step is it's own component in the router.
  // Upon submission of each step, state is updated in this component
  // Upon submission of final step, request is sent to back-end
  state = {
    client: {},
    isMobile: false,
    navExtras: {}
  };

  render() {
    return (
      <OnboardingProvider className="cms" onboardingType="client">
        {/*<button type="button" onClick={this.postSignup}>Test</button>*/}
        {/*<OnboardingResetButton localReset={this.reset} />*/}
        {this.state.isMobile
          ? this.renderMobileLayout()
          : this.renderDesktopLayout()}
      </OnboardingProvider>
    );
  }

  renderDesktopLayout() {
    const { isMobile } = this.state;

    return (
      <div className="on-boarding on-boarding--client">
        {this.renderMain()}
        <div className="on-boarding__right">
          <OnboardingNav
            isMobile={isMobile}
            subject={this.state.client}
            extras={this.state.navExtras}
          />
          <OnboardingSubmitContainer />
        </div>
      </div>
    );
  }

  renderMobileLayout() {
    const { isMobile } = this.state;
    return (
      <div className="on-boarding on-boarding--client">
        <OnboardingNav
          isMobile={isMobile}
          subject={this.state.client}
          extras={this.state.navExtras}
        />
        {this.renderMain()}
        <OnboardingSubmitContainer />
      </div>
    );
  }

  renderMain() {
    const { updateClient, updateNavExtras } = this;
    const { client } = this.state;
    return (
      <div className="on-boarding__main">
        <OnboardingSteps>
          <OnboardingStep
            step={0}
            resets={[]}
            path={`${this.props.match.url}`}
            navLabel="Email & Zip"
            navComponent={ClientContactNav}
            mainComponent={ClientContact}
            mainProps={{ updateClient, client }}
            submitComponent={OnboardingSubmitDefault}
            submitProps={{
              disabledCopy: 'Enter Info',
              enabledCopy: 'Continue'
            }}
          />

          <OnboardingStep
            step={1}
            resets={[2, 3]}
            path={`${this.props.match.url}/step-2`}
            navLabel="Service Time"
            navComponent={ClientServiceTimeNav}
            mainComponent={ClientServiceTime}
            mainProps={{ updateClient, client }}
            submitComponent={OnboardingSubmitDefault}
            submitProps={{
              disabledCopy: 'Select Service Time',
              enabledCopy: 'Continue'
            }}
          />

          <OnboardingStep
            step={2}
            resets={[3]}
            path={`${this.props.match.url}/step-3`}
            navLabel="Start Date"
            navComponent={ClientStartDateNav}
            mainComponent={ClientStartDate}
            mainProps={{ updateClient, client }}
            submitComponent={OnboardingSubmitDefault}
            submitProps={{
              disabledCopy: 'Select Date',
              enabledCopy: 'Continue'
            }}
          />

          <OnboardingStep
            step={3}
            resets={[]}
            path={`${this.props.match.url}/step-4`}
            navLabel="Menu"
            navComponent={ClientMenuNav}
            mainComponent={ClientMenu}
            mainProps={{ updateClient, client, updateNavExtras }}
            submitComponent={OnboardingSubmitSkip}
            submitProps={{
              disabledCopy: 'Choose up to Six',
              enabledCopy: 'Continue'
            }}
          />

          <OnboardingStep
            step={4}
            path={`${this.props.match.url}/step-5`}
            navLabel="Culinary Preferences"
            navComponent={ClientPreferencesNav}
            mainComponent={ClientPreferences}
            mainProps={{ updateClient, client }}
            submitComponent={OnboardingSubmitDefault}
          />

          <OnboardingStep
            step={5}
            path={`${this.props.match.url}/step-6`}
            navLabel="Account Details"
            // navComponent={ChefLocationsNav}
            // navComponent={() => ''}
            mainComponent={ClientDetails}
            mainProps={{ updateClient, client, postSignup: this.postSignup }}
            submitComponent={OnboardingSubmitConfirm}
            submitProps={{
              disabledCopy: 'Add Account & Billing Info',
              enabledCopy: 'Complete Account Creation',
              confirmCopy: (
                <p>
                  I've read and accept the{' '}
                  <a
                    href={
                      ENV_CONFIG.REACT_APP_SCHEMA +
                      '://' +
                      ENV_CONFIG.REACT_APP_WWW_HOST +
                      '/terms'
                    }
                    target="_blank"
                  >
                    terms & conditions
                  </a>
                </p>
              ),
              checkboxCallback: this.updateTerms
            }}
          />
        </OnboardingSteps>
      </div>
    );
  }

  updateTerms = val =>
    this.updateClient({ accepted_terms_and_conditions: val });

  // to be called in final step of on boarding
  postSignup = () => {
    // mutate payload
    const client = this.mutateClientPayload({ ...this.state.client });
    // todo: sample payload... leaving here for now.
    // const client = {
    //     "accepted_terms_and_conditions": true,
    //     "email": "david@wondersauce.com",
    //     "first_name": "First",
    //     "last_name": "Last",
    //     "notes": "I don't eat bananas.",
    //     "password": "B@r3Minimum!",
    //     "password_confirmation": "B@r3Minimum!",
    //     "phone_number": "1-203-867-5309",
    //     "portion_size": "small",
    //     "redirect_url": "http://localhost:5000",
    //     "service_start_date": "Fri, 01 Apr 2022",
    //     "stripe_token": "tok_visa",
    //     "service_addresses": [{
    //         "street_address": "205 1st Avenue",
    //         "street_address_continued": "Apartment 3",
    //         "city": "New York",
    //         "state": "NY",
    //         "zip_code": "10010"
    //     }],
    //     "client_service_preferences": [{
    //         "start_time": "08:00",
    //         "day_of_week": 'thursday'
    //     }]
    // };

    // client.payment =  {
    //   cc_number: "4111111111111111",
    //   expiration_date: "2020-05",
    //   code: "111",
    //
    //   city: "New York",
    //   state: "NY",
    //   address: "1 Main Street",
    //   zip_code: "10000"
    // };

    onBoardingAPI
      .createClient(client)
      .then(({ errors, messages, client }) => {
        if (messages)
          this.props.addMessage({
            className: 'error',
            message: messages.join(', ')
          });
        this.reset();
        this.props.history.push({ pathname: '/new-client/thank-you' });
      })
      .catch(err =>
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err)
        })
      );
  };

  mutateClientPayload = client => {
    const dates = client.payment.expiration_date.split(' / ');
    const expiration_date = `20${dates[1]}-${dates[0]}`;
    const cc_number = client.payment.cc_number.replace(/\s/g, '');

    client.payment = {
      ...client.payment,
      cc_number,
      expiration_date
    };

    if (client.client_service_preferences.length) {
      client.client_service_preferences[0] = {
        ...client.client_service_preferences[0],
        start_date: client.service_start_date
      };
    }
    return client;
  };

  // didClientChange(updatedClient){
  //   const {client} = this.state;
  //   const props = Object.keys(updatedClient);
  //   return !props.every(prop => updatedClient[prop] === client[prop]);
  // }

  updateClient = (updatedClient, cb = () => {}) => {
    // update the client
    const client = { ...this.state.client, ...updatedClient };
    this.setState({ client }, cb);
  };

  updateNavExtras = (updatedNavExtras, cb = () => {}) => {
    // update the client
    const navExtras = { ...this.state.navExtras, ...updatedNavExtras };
    this.setState({ navExtras }, cb);
  };

  reset = () => {
    localStorage.removeItem('client-on-boarding');
    this.setState({ client: {} });
    this.props.history.push({ pathname: this.props.match.url });
  };

  componentWillMount() {
    // load from local storage
    const localStorageRef = localStorage.getItem(`client-on-boarding`);
    if (localStorageRef) {
      this.setState(JSON.parse(localStorageRef));
    }
  }

  componentWillUpdate(nextProps, nextState) {
    // don't store these ever
    const safeSpace = {
      password: '',
      password_confirmation: '',
      payment: {
        ...nextState.client.payment,
        cc_number: '',
        expiration_date: '',
        code: ''
      }
    };
    // save to local storage
    localStorage.setItem(
      `client-on-boarding`,
      JSON.stringify({ client: { ...nextState.client, ...safeSpace } })
    );
  }

  componentDidUpdate(prevProps, prevState) {
    // todo: WARNING THIS IS OFF BY THE WIDTH OF THE SCROLL BAR
    const isMobile = this.props.windowWidth < breakpoints.tablet;
    if (this.state.isMobile !== isMobile) this.setState({ isMobile });
  }
}

export default withSplashMessage(withTracker(ClientOnboarding));



// WEBPACK FOOTER //
// ./src/components/onboarding/ClientOnboarding.js